import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '../shared/shared.module';
import { BadgeModule } from 'primeng/badge';
import { SideNotificationsComponent } from './components/side-notifications/side-notifications.component';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DividerModule } from 'primeng/divider';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { AvatarGeneratorComponent } from '../shared/components/avatar-generator/avatar-generator.component';
import { EmptyStateLoadingComponent } from '../shared/components/empty-state-loading/empty-state-loading.component';
import { MenuModule } from 'primeng/menu';

@NgModule({
  declarations: [NotificationListComponent, SideNotificationsComponent],
  exports: [NotificationListComponent, SideNotificationsComponent],
  providers: [DialogService, MessageService],
  imports: [
    CommonModule,
    FormsModule,
    NotificationsRoutingModule,
    ButtonModule,
    BadgeModule,
    SharedModule,
    ProgressSpinnerModule,
    DividerModule,
    InputSwitchModule,
    AvatarGeneratorComponent,
    EmptyStateLoadingComponent,
    MenuModule
  ]
})
export class NotificationsModule {}
